(function () {
  'use strict';

  // ---------- Data ----------
  var dataEl = document.getElementById('byp-variant-data');
  var DATA = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], refill: {} };
  var VARIANTS = DATA.variants || [];
  var REFILL = DATA.refill || {};

  var SIZES = uniq(VARIANTS.map(function (v) { return v.size; }));
  var COLORS = uniq(VARIANTS.map(function (v) { return v.color; }));

  function uniq(arr) {
    return arr.filter(function (v, i) { return v && arr.indexOf(v) === i; });
  }

  function findVariant(size, color) {
    return VARIANTS.find(function (v) { return v.size === size && v.color === color; }) || null;
  }

  function money(n) {
    return '$' + Number(n).toFixed(2);
  }

  // ---------- State ----------
  var TIER_SLOT_COUNT = { single: 1, '3': 3, '6': 6 };
  var TIER_FREE_COUNT = { single: 0, '3': 1, '6': 2 };

  var state = {
    tier: '3',
    slots: [], // [{size, color}]
    refillOn: false
  };

  function defaultSlots(count) {
    var slots = [];
    for (var i = 0; i < count; i++) {
      slots.push({
        size: SIZES[0] || null,
        color: COLORS[i % COLORS.length] || null
      });
    }
    return slots;
  }

  state.slots = defaultSlots(TIER_SLOT_COUNT[state.tier]);

  // ---------- Cheapest-free math (mirrors checkout: cheapest N eligible items free) ----------
  function computePricing() {
    var freeCount = TIER_FREE_COUNT[state.tier];
    var lines = state.slots.map(function (slot, idx) {
      var variant = findVariant(slot.size, slot.color);
      return {
        idx: idx,
        size: slot.size,
        color: slot.color,
        variant: variant,
        price: variant ? parseFloat(variant.price) : 0
      };
    });

    // Rank by price ascending to find which N are free — same rule Shopify's
    // Buy X Get Y applies (discounts the cheapest eligible items first).
    var ranked = lines.slice().sort(function (a, b) { return a.price - b.price; });
    var freeIdxSet = {};
    for (var i = 0; i < freeCount && i < ranked.length; i++) {
      freeIdxSet[ranked[i].idx] = true;
    }

    var subtotal = 0;
    lines.forEach(function (line) {
      line.isFree = !!freeIdxSet[line.idx];
      subtotal += line.isFree ? 0 : line.price;
    });

    var refillPrice = state.refillOn ? parseFloat(REFILL.price || 0) : 0;
    var total = subtotal + refillPrice;

    return { lines: lines, subtotal: subtotal, refillPrice: refillPrice, total: total, freeCount: freeCount };
  }

  // ---------- Rendering ----------
  var elBuilder = document.querySelector('[data-slot-grid]');
  var elSummaryLines = document.querySelector('[data-summary-lines]');
  var elTotal = document.querySelector('[data-total-price]');
  var elStickyTotal = document.querySelector('[data-sticky-total]');
  var elRefillToggle = document.querySelector('[data-refill-toggle]');
  var elRefillPrice = document.querySelector('[data-refill-price]');
  var elStickyBar = document.querySelector('[data-sticky-cta]');
  var elSummaryCard = document.querySelector('[data-summary]');

  function renderBuilder() {
    if (!elBuilder) return;
    elBuilder.innerHTML = '';
    var pricing = computePricing();

    state.slots.forEach(function (slot, idx) {
      var line = pricing.lines[idx];
      var wrap = document.createElement('div');
      wrap.className = 'byp-slot' + (line.isFree ? ' byp-slot--free' : '');

      if (line.isFree) {
        var tag = document.createElement('span');
        tag.className = 'byp-slot__free-tag';
        tag.textContent = 'FREE';
        wrap.appendChild(tag);
      }

      wrap.appendChild(makeSelect('Size', SIZES, slot.size, function (val) {
        state.slots[idx].size = val;
        renderAll();
      }));
      wrap.appendChild(makeSelect('Color', COLORS, slot.color, function (val) {
        state.slots[idx].color = val;
        renderAll();
      }));

      elBuilder.appendChild(wrap);
    });
  }

  function makeSelect(label, options, selected, onChange) {
    var container = document.createElement('label');
    container.style.display = 'block';
    container.style.fontSize = '13px';
    container.style.marginTop = '8px';
    container.textContent = label;

    var select = document.createElement('select');
    options.forEach(function (opt) {
      var o = document.createElement('option');
      o.value = opt;
      o.textContent = opt;
      if (opt === selected) o.selected = true;
      select.appendChild(o);
    });
    select.addEventListener('change', function () { onChange(select.value); });

    container.appendChild(select);
    return container;
  }

  function renderSummary() {
    var pricing = computePricing();

    if (elSummaryLines) {
      elSummaryLines.innerHTML = '';
      pricing.lines.forEach(function (line) {
        var li = document.createElement('li');
        li.dataset.free = line.isFree ? 'true' : 'false';
        var label = document.createElement('span');
        // Copy rule: line items match checkout exactly -> "Freezball {Size} · {Color}"
        label.textContent = 'Freezball ' + (line.size || '—') + ' · ' + (line.color || '—');

        var priceEl = document.createElement('span');
        if (line.isFree) {
          var strike = document.createElement('span');
          strike.className = 'byp-line-price';
          strike.textContent = money(line.price);
          var freeBadge = document.createElement('span');
          freeBadge.className = 'byp-badge-free';
          freeBadge.textContent = 'FREE';
          priceEl.appendChild(strike);
          priceEl.appendChild(freeBadge);
        } else {
          priceEl.textContent = money(line.price);
        }

        li.appendChild(label);
        li.appendChild(priceEl);
        elSummaryLines.appendChild(li);
      });
    }

    if (elTotal) elTotal.textContent = money(pricing.total);
    if (elStickyTotal) elStickyTotal.textContent = money(pricing.total);
    if (elRefillPrice) elRefillPrice.textContent = money(REFILL.price || 14.95);
  }

  function renderTierFromPrices() {
    // "From" prices computed live, never hard-coded, per brief.
    var singleVariant = VARIANTS[0];
    var singleFrom = singleVariant ? parseFloat(singleVariant.price) : 0;

    var sorted = VARIANTS.slice().sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    var cheapest = sorted.length ? parseFloat(sorted[0].price) : 0;

    // 3-pack "from": 3x cheapest, minus the cheapest (free) = 2x cheapest
    var threeFrom = cheapest * 2;
    // 6-pack "from": 6x cheapest, minus 2x cheapest (free) = 4x cheapest
    var sixFrom = cheapest * 4;

    setFrom('single', singleFrom);
    setFrom('3', threeFrom);
    setFrom('6', sixFrom);
  }

  function setFrom(tier, price) {
    var el = document.querySelector('[data-from-price="' + tier + '"]');
    if (el) el.textContent = 'from ' + money(price);
  }

  function renderAll() {
    renderBuilder();
    renderSummary();
  }

  // ---------- Tier switching ----------
  document.querySelectorAll('[data-tier]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tier = btn.getAttribute('data-tier');
      state.tier = tier;
      state.slots = defaultSlots(TIER_SLOT_COUNT[tier]);

      document.querySelectorAll('[data-tier]').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('byp-tier--selected', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      renderAll();
    });
  });

  // ---------- Refills toggle ----------
  if (elRefillToggle) {
    elRefillToggle.addEventListener('change', function () {
      state.refillOn = elRefillToggle.checked;
      renderSummary();
    });
  }

  // ---------- Sticky mobile CTA ----------
  if (elSummaryCard && elStickyBar && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        elStickyBar.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });
    io.observe(elSummaryCard);
  }

  // ---------- UTM preservation ----------
  function currentUTMParams() {
    var params = new URLSearchParams(window.location.search);
    var utm = new URLSearchParams();
    params.forEach(function (value, key) {
      if (key.toLowerCase().indexOf('utm_') === 0) utm.set(key, value);
    });
    return utm;
  }

  // ---------- Checkout permalink ----------
  // Format: /cart/{v}:1,{v}:1,{v}:1[,{refillVariant}:1]?discount=FREEZPACK&storefront=true&<utm>
  // FREEZPACK is only appended for 3- and 6-bone tiers (the pack tiers).
  // Single-item purchases get no discount param, matching "normal purchase, normal shipping."
  function buildPermalink() {
    var pricing = computePricing();
    var variantParts = pricing.lines
      .filter(function (l) { return l.variant; })
      .map(function (l) { return l.variant.variantId + ':1'; });

    if (state.refillOn && REFILL.variantId) {
      variantParts.push(REFILL.variantId + ':1');
    }

    var path = '/cart/' + variantParts.join(',');
    var query = new URLSearchParams();
    query.set('storefront', 'true');

    if (state.tier === '3' || state.tier === '6') {
      query.set('discount', 'FREEZPACK'); // hidden — never surfaced in UI copy
    }

    var utm = currentUTMParams();
    utm.forEach(function (value, key) { query.set(key, value); });

    return path + '?' + query.toString();
  }

  // ---------- CTA click: fire pixels, then jump straight to checkout ----------
  document.querySelectorAll('[data-add-pack]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      firePixel('AddToCart');
      firePixel('InitiateCheckout');
      window.location.href = buildPermalink();
    });
  });

  function firePixel(eventName) {
    try {
      if (window.fbq) window.fbq('track', eventName);
      if (window.ttq) window.ttq.track(eventName);
    } catch (e) { /* pixels not loaded yet — non-blocking */ }
  }

  // ---------- Init ----------
  document.addEventListener('DOMContentLoaded', function () {
    renderTierFromPrices();
    renderAll();
    firePixel('ViewContent');
  });

  if (document.readyState !== 'loading') {
    renderTierFromPrices();
    renderAll();
    firePixel('ViewContent');
  }
})();
